<template>
  <v-dialog persistent v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <slot :on="on" :attrs="attrs" :edit="edit" :fetching="fetchingData">
        <div>
          <v-btn color="primary" dark dense v-bind="attrs" v-on="on">
            Transfer Inventory
          </v-btn>
        </div>
      </slot>
    </template>
    <v-card>
      <v-toolbar dark :color="!isEdit ? 'primary' : 'yellow darken-3'">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Transfer</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn v-if="!isEdit" dark text @click="save">
            Save
          </v-btn>
          <v-btn v-else dark text @click="update">
            Update
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>
        <v-row>
          <v-col cols="12" class="pa-1">
            <v-card>
              <v-toolbar :color="!isEdit ? 'primary' : 'yellow darken-3'" flat dark dense> Details</v-toolbar>
              <div class="pa-2 details space-x-2.5">
                <v-text-field label="Receipt No" outlined hide-details="auto" dense v-model="receiptNo"
                  @change="storeToLocal" :error-messages="validationErrors.receipt_no" />
                <v-text-field label="Order No" outlined hide-details="auto" dense v-model="orderNo"
                  :error-messages="validationErrors.order_no" @change="storeToLocal" />
                <v-text-field type="Date" label="date" outlined hide-details="auto" dense v-model="date"
                  @change="storeToLocal" :error-messages="validationErrors.date" />
                <v-autocomplete label="Store Name" outlined hide-details="auto" dense item-value="id" item-text="name"
                  v-model="toStore" :items="branches" @change="storeToLocal"
                  :error-messages="validationErrors.to_store">
                  <template>
                  </template>
                </v-autocomplete>
                <v-text-field label="Cost of Transport" type="number" outlined hide-details="auto" dense
                  v-model.number="costOfTransport" :error-messages="validationErrors.cost_of_transport" />
              </div>
            </v-card>
          </v-col>
          <v-col class="pa-1" cols="12" lg="4">
            <v-card>
              <v-toolbar flat dense :color="!isEdit ? 'primary' : 'yellow darken-3'" dark class="mb-5">
                Add Item
              </v-toolbar>
              <v-row class="mx-2">
                <v-col cols="12">
                  <v-autocomplete label="Stock Code" hide-details="auto" outlined :items="splrPdList"
                    :search-input.sync='searchInput' :loading='splrPdLoading' dense item-value='stock_code' no-filter
                    @change="stockCodeChange" return-object v-model="selectedStock">
                    <template v-slot:selection="{ item }">
                      <span>{{ item.supplier_id }}-{{ item.stock_code
                      }}
                      </span>
                      <span class="blue-grey--text mx-1 text-caption">{{ item.product_name }} ({{
                        item.brand_name
                      }})
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span class="blue--text">
                        {{ item.supplier_id }}-{{
                          item.stock_code }}
                      </span>
                      <span class="mx-1"></span>
                      <small>{{ item.product_name }} ({{
                        item.brand_name
                      }})</small>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="SRP" prefix="₱" type="number" outlined dense hide-details="auto"
                    v-model.number="retail"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field type="number" outlined dense hide-details="auto" v-model="quantity">
                    <template v-slot:label>
                      <span>Quantity</span>
                      <span class="mx-1"></span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete @change="onUnitChange" :items="units" label="Unit" type="string" outlined dense
                    hide-details="auto" v-model="unit">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-textarea label="Notes" auto-grow="auto-grow" no-resize="no-resize" outlined hide-details="auto"
                    dense rows="1" v-model="notes"></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-btn color="green" block @click="addItem">Add Item</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col class="pa-1" cols="12" lg="8">
            <v-card>
              <v-toolbar dense flat :color="!isEdit ? 'primary' : 'yellow darken-3'" dark=""><span>Items</span>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text style="overflow: auto;">
                <v-responsive>
                  <v-simple-table dense>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Product</th>
                        <th>Qty</th>
                        <th>Amt</th>
                        <th v-if="isEdit">Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in items" :key="item.stockId">
                        <td :class="`${item.status === 'cancelled' && 'line-through red'}`">
                          <div v-if="itemsErrorExist(index)">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon color="red" v-bind="attrs" v-on="on">mdi-alert</v-icon>
                                {{ index + 1 }}
                              </template>
                              <p>
                                <span v-for="(error, errorIndex) in listRowErrors(index)" :key="errorIndex">
                                  {{ error }}<br />
                                </span>
                              </p>
                            </v-tooltip>
                          </div>
                          <div v-else>{{ index + 1 }}</div>
                        </td>
                        <td :class="`${item.status === 'cancelled' && 'line-through red'}`">{{ item.stock.product_name
                        }}
                        </td>
                        <td :class="`${item.status === 'cancelled' && 'line-through red'}`">{{ item.quantity }}
                          <small v-if="item.unit">({{ item.unit }})</small>
                        </td>
                        <td :class="`text-right ${item.status === 'cancelled' && 'line-through red'}`">{{
                          formatAccounting(item.quantity * item.retail) }}</td>
                        <td v-if="isEdit" :class="`${item.status === 'cancelled' && 'line-through red'}`">{{ item.status
                        }}
                        </td>
                        <td :class="`${item.status === 'cancelled' && 'line-through red'}`">
                          <v-btn small text v-if="!item.fromDatabase" @click="removeItem(item.stockId)">
                            <v-icon color="red">mdi-delete</v-icon>
                          </v-btn>
                          <v-btn small :loading="item.deleting" dense text
                            v-else-if="item.fromDatabase && item.status === 'pending'">
                            <v-icon color="red" @click="deleteItem(item)">mdi-delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-responsive>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="px-1" v-if="isEdit && storeTransfer.id">
            <v-card class="ma-0">
              <v-toolbar flat color="primary" dense dark>Payments</v-toolbar>
              <v-container>
                <create-transaction @delete-success="$emit('save-success')" @store-success="$emit('save-success')"
                  ref="createTransactionRef" :store-transfer-id="storeTransfer.id" />
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<style scoped lang="scss">
.details {
  display: flex;
}
</style>
<script>
import axios from '@/extra-functions/axios.extra'
import splrPdRepository from '@/repositories/supplier-product.repository'
import { apiVars } from '@/extra-functions/api-helper.extra'
import { mapActions, mapState } from 'vuex'
import { useDebounce, useWatchEffect, camelToSnake, formatAccounting, getCurrentDate } from '@/lib/utils'
import LocalStore from '../../../../lib/localStore'
import { dynamicUnit, ErrorPopup } from '../../../../lib/utils'


const [searchInputWatchEffect, clearSearchInputWatchEffect] = useWatchEffect()
const searchInputDebounce = useDebounce()


const itemVars = () => {
  return {
    stockId: null,
    retail: null,
    quantity: null,
    notes: null,
    unit: '',
  }
}


const inputVars = () => {
  return {
    receiptNo: null,
    date: getCurrentDate(),
    orderNo: null,
    costOfTransport: 0,
    toStore: null,
  }
}

const createTransferInventoryRequestSchema = {
  createTransferInventoryRequest: {
    ...inputVars(),
    unsavedChanges: false,
    items: [],
  },
}
const localStore = new LocalStore({ schema: createTransferInventoryRequestSchema })


export default {
  name: 'CreateTransferInventoryRequest',
  components: {
    createTransaction: () => import('./CreateTransferTransactionInventory'),
  },
  data() {
    return {
      dialog: false,
      ...apiVars('splrPd', {
        uploadErrors: [],
        uploading: false,
      }),
      selectedStock: {},
      splrPdLoading: false,
      searchInput: '',
      stockInCart: new Set(),
      storing: false,
      items: [],
      validationErrors: {},
      storeTransfer: {},
      fetchingData: false,
      isEdit: false,
      ...itemVars(),
      ...inputVars(),
    }
  },
  created() {
    searchInputWatchEffect((onCleanup) => {
      const controller = new AbortController()
      onCleanup(() => {
        controller.abort()
      })
      searchInputDebounce(() => {
        this.getSplrPd(controller)
      })
    })
    this.getLocalData()
    this.$store.dispatch('unit/fetchAll')
  },
  computed: {
    ...mapState({
      authToken: state => state.auth.token,
      selectedStoreId: state => state.settings.storeId,
      branches: state => state.branchLocation.list.filter(item => item.id !== state.settings.storeId),
      units: state => state.unit.allList.map(unit => unit.unit),
    }),
    // allInputs() {
    //   const items = this.items.join(',')
    //   return `${this.receiptNo},${this.date},${this.orderNo},${this.costOfTransport},${this.toStore},${items}`
    // },
  },
  destroyed() {
    clearSearchInputWatchEffect()
  },
  watch: {
    searchInput() {
      searchInputWatchEffect((onCleanup) => {
        const controller = new AbortController()
        onCleanup(() => {
          controller.abort()
        })
        searchInputDebounce(() => {
          this.getSplrPd(controller)
        })
      })
    },
    // allInputs() {
    //   this.storeToLocal()
    // },
  },
  methods: {
    async edit(storeTransferId) {
      try {
        this.isEdit = true
        this.dialog = true
        if (this.fetchingData) return
        this.fetchingData = true
        this.dialog = true
        const { data } = await axios(this.authToken).get(`/store-transfers/${storeTransferId}/edit`)
        this.storeTransfer = data
        this.receiptNo = data.receipt_no
        this.date = data.date
        this.orderNo = data.order_no
        this.costOfTransport = data.cost_of_transport
        this.toStore = data.to_store
        this.items = data.items.map(item => {
          return {
            id: item.id,
            stockId: item.from_stock_id,
            retail: item.retail,
            quantity: item.quantity,
            notes: item.notes,
            status: item.status,
            unit: item.unit,
            stock: item.from_stock,
            fromDatabase: true,
          }
        })
      } catch (e) {
        console.error(e.message)
        this.$alertSwalError('oops something went wrong')
      } finally {
        this.fetchingData = false
      }
    },
    resetItem() {
      const defaultVars = itemVars()
      Object.keys(defaultVars).forEach(key => {
        this[key] = defaultVars[key]
      })
      this.selectedStock = {}
    },
    resetAll() {
      const defaultInputVars = inputVars()
      this.resetItem()
      Object.keys(defaultInputVars).forEach(key => {
        this[key] = defaultInputVars[key]
      })
      this.stockInCart = new Set()
      this.dialog = false
      this.items = []

      localStore.delete('createTransferInventoryRequest')
      this.$store.dispatch('appDrawer/setTransferUnsavedChanges', false)
    },
    addItem() {
      try {
        if (this.stockInCart.has(this.stockId)) {
          this.items = this.items.map(item => {
            if (item.stockId !== this.stockId) return item
            return {
              ...item,
              quantity: item.quantity + 1,
            }
          })
          return
        }
        this.items.push({
          stockId: this.stockId,
          retail: this.retail,
          quantity: this.quantity,
          notes: this.notes,
          unit: this.unit,
          stock: { ...this.selectedStock },
        })
        this.stockInCart.add(this.stockId)
        this.resetItem()
        this.storeToLocal()
      } catch (e) {
        this.$alertSwalError('oops something went wrong')
      }
    },
    async getSplrPd() {
      try {
        this.splrPdLoading = true
        const { data } = await splrPdRepository.paginate(this.selectedStoreId, { search: this.searchInput })
        this.splrPdList = data
      } catch (e) {

      } finally {
        this.splrPdLoading = false
      }
    },
    stockCodeChange(stock) {
      this.stockId = stock.stock_id
      this.retail = stock.retail
      this.quantity = 1
      this.unit = stock.unit
    },
    async save() {
      try {
        if (this.storing) return
        this.storing = true
        const inputs = Object.keys(inputVars()).reduce((prev, next) => {
          const snakeKey = camelToSnake(next)
          prev[snakeKey] = this[next]
          return prev
        }, {})
        const items = this.items.map(item => {
          return {
            from_stock_id: item.stockId,
            retail: item.retail,
            quantity: item.quantity,
            notes: item.notes,
            unit: item.unit,
          }
        })
        const data = {
          ...inputs,
          items,
        }
        const result = await axios(this.authToken).post('/store-transfers', data)
        this.resetAll()
        this.$emit('save-success')
      } catch (e) {
        if (e?.response) {
          this.validationErrors = { ...e?.response?.data?.errors }
          if (this.validationErrors?.items) {
            ErrorPopup.fire({
              title: 'Validation Error',
              text: this.validationErrors?.items[0],
              icon: 'error',
            })
          }
          return
        }
        ErrorPopup.fire('Oops something went wrong')
      } finally {
        this.storing = false
      }
    },
    async update() {
      try {
        if (this.storing) return
        this.storing = true
        const inputs = Object.keys(inputVars()).reduce((prev, next) => {
          const snakeKey = camelToSnake(next)
          prev[snakeKey] = this[next]
          return prev
        }, {})
        const items = this.items.filter(item => !item?.fromDatabase).map(item => {
          return {
            from_stock_id: item.stockId,
            retail: item.retail,
            quantity: item.quantity,
            notes: item.notes,
            unit: item.unit,
          }
        })
        const data = {
          ...inputs,
          items,
        }
        const result = await axios(this.authToken).put(`/store-transfers/${this.storeTransfer.id}`, data)
        this.resetAll()
        this.$emit('save-success')
      } catch (e) {
        if (e?.response) {
          this.validationErrors = { ...e?.response?.data?.errors }
        }
      } finally {
        this.storing = false
      }
    },
    removeItem(stockId) {
      this.items = this.items.filter(item => item.stockId !== stockId)
      this.stockInCart.delete(stockId)
    },
    async deleteItem(storeTransferItem) {
      try {
        this.$confirm('are you sure you want to remove this item?')
        if (storeTransferItem.deleting) return
        storeTransferItem.deleting = true

        this.items = [...this.items]
        const result = await axios(this.authToken).delete(`/store-transfer-items/${storeTransferItem.id}`)
        this.items = this.items.filter(item => item.id !== storeTransferItem.id)
      } catch (e) {
        console.error(e)
        this.$alertSwalError('oops something went wrong')
      }
    },
    getLocalData() {
      const createTransferInventoryRequestLocalData = localStore.get('createTransferInventoryRequest')
      Object.keys(inputVars()).forEach(key => {
        this[key] = createTransferInventoryRequestLocalData[key]
      })
      this.items = createTransferInventoryRequestLocalData.items
    },
    storeToLocal() {
      if (this.isEdit) return
      const inputs = Object.keys(inputVars()).reduce((prev, next) => {
        prev[next] = this[next]
        return prev
      }, {})
      const data = {
        ...inputs,
        items: this.items,
        unsavedChanges: true,
      }
      localStore.set({
        createTransferInventoryRequest: data,
      })
      this.$store.dispatch('appDrawer/setTransferUnsavedChanges', true)
    },
    formatAccounting,
    onUnitChange(unit) {
      const stock = this.selectedStock
      const quantityPerUnit = dynamicUnit(unit, 1)
      this.retail = quantityPerUnit * stock.retail
    },
    itemsErrorExist(index) {
      const errorKeys = [
        'from_stock_id',
        'retail',
        'quantity',
        'unit',
      ]
      const errors = new Set(Object.keys(this.validationErrors))
      return errorKeys.some(key => errors.has(`items.${index}.${key}`))
    },
    listRowErrors(index) {
      const errorKeys = [
        'from_stock_id',
        'retail',
        'quantity',
        'unit',
      ]
      const errors = []
      errorKeys.forEach(key => {
        const error = this.validationErrors[`items.${index}.${key}`]
        if (error) {
          errors.push(error[0])
        }
      })
      return errors
    },
  },
}
</script>
